<hs-no-loaded-account [content]="loadedAccountDependentContent">
</hs-no-loaded-account>

<ng-template #loadedAccountDependentContent>
  <hs-cache-load-listener
    [content]="cacheDependentContent"
    [sessionCacheStatus]="sessionCacheStatus"
    [sessionId]="lastProcessedSessionId"
    [accountIds]="lastProcessedAccountIds"
    [notApplicable]="notApplicable"
    [notApplicableMessage]="notApplicableMessage"
  ></hs-cache-load-listener>
</ng-template>

<ng-template #cacheDependentContent>
  <hs-clearwater-transactions-grid
    #cwTransactionsGrid
    [cacheLoadStatus]="sessionCacheStatus"
    [filteredExtTranIds]="filteredExtTranIds | async"
    [securityIdFilter]="securityIdFilter | async"
    [currencyFilter]="currencyFilter | async"
    [rowsUpdated]="updatedTransactions | async"
    [rowsCreated]="createdTransactions | async"
    [focusedTranId]="focusedTranId$ | async"
    [focusedTranIds]="focusedTranIds$ | async"
    [focusedLegacyTranIds]="focusedLegacyTranIds$ | async"
    [focusedLegacyOrigIds]="focusedLegacyOrigIds$ | async"
    [focusedAssetId]="focusedAssetId"
    [externalTransactionSelection]="externalTransactionSelection"
    [isSelectAllRowsEnabled]="isSelectAllRowsEnabled | async"
    (createCashEntryAction)="createCashEntryTx()"
    (createTradeEntryAction)="createTradeEntryTx()"
    (createFxSpotTradeAction)="createFxSpotTradeTx()"
    (createFxForwardAction)="createFxForwardTx()"
    (createDirectTransferAction)="createDirectTransferTx()"
    (createWireTransferAction)="createWireTransferTx()"
    (createSecurityTransferAction)="createSecurityTransferTx()"
    (transactionsSelected)="onTransactionsSelected($event)"
    (selectAllTransState)="onSelectAllTransactionState($event)"
    [sessionStartTime]="sessionCacheStartTime"
  ></hs-clearwater-transactions-grid>
</ng-template>
